export const toFontFamilyString = fontFamilyArray => `'${fontFamilyArray.join("', '")}'`;
